import type { ReactNode } from "react";

type OrderDetailLayoutProps = {
  header: ReactNode;
  sidebar: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
};

export function OrderDetailLayout({
  header,
  sidebar,
  children,
  footer,
}: OrderDetailLayoutProps) {
  return (
    <div className="flex h-full flex-col overflow-hidden">
      {header}
      <div className="min-h-0 flex-1 overflow-y-auto">
        <div className="mx-auto flex max-w-6xl flex-col gap-4 p-4 lg:flex-row lg:items-start lg:gap-6">
          <div className="min-w-0 flex-1 space-y-4">{children}</div>
          <aside className="w-full shrink-0 space-y-4 lg:sticky lg:top-4 lg:w-80 xl:w-96">
            {sidebar}
          </aside>
        </div>
        {footer}
      </div>
    </div>
  );
}
